import { Props } from "./FileReaderInput";

export { default } from "./FileReaderInput";
export type FileReaderInputProps = Props;
